export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14852.5ca64dfb.jpg";